import React from "react";
import Tooltip from "../tooltip/tooltip.tsx";
import "./styleButton.css";

interface StyleButtonProps {
  content: string;
  subtitle?: string;
  icon?: React.ReactNode;
  fontColor?: string;
  fontColorSelected?: string;
  backgroundColor?: string;
  backgroundColorSelected?: string;
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  tooltipText?: string;
}

const StyleButton: React.FC<StyleButtonProps> = ({
  content,
  subtitle,
  icon,
  fontColor = "var(--color-dark-blue)",
  fontColorSelected = "var(--color-white)",
  backgroundColor = "var(--color-gray)",
  backgroundColorSelected = "var(--color-dark-blue)",
  isSelected = false,
  disabled = false,
  onClick,
  tooltipText,
}) => {
  const darkenColor = (color: string): string => {
    if (color.startsWith("var(")) {
      if (color.includes("--color-gray")) return "#b8b8b8";
      if (color.includes("--color-dark-blue")) return "#1e3c5a";
      if (color.includes("--color-blue")) return "#3d6b9c";
      if (color.includes("--color-light-blue")) return "#2a8fa6";
      if (color.includes("--color-teal")) return "#026d7a";
      if (color.includes("--color-green")) return "#1a8b60";
      if (color.includes("--color-orange")) return "#c5471a";
      if (color.includes("--color-yellow")) return "#b8750a";
      return "#999999";
    }
    return color;
  };

  const currentBackgroundColor = isSelected
    ? backgroundColorSelected
    : backgroundColor;
  const shapeColor = darkenColor(currentBackgroundColor);
  const hoverColor = darkenColor(backgroundColor);

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`styleButton-container ${
        isSelected ? "styleButton-selected" : ""
      } ${disabled ? "styleButton-disabled" : ""}`}
      style={
        {
          "--styleButton-font-color": fontColor,
          "--styleButton-font-color-selected": fontColorSelected,
          "--styleButton-background-color": backgroundColor,
          "--styleButton-background-color-selected": backgroundColorSelected,
          "--styleButton-background-color-hover": hoverColor,
        } as React.CSSProperties
      }
      onClick={handleClick}
      disabled={disabled}
    >
      <svg
        className="styleButton-icon-top-left"
        width="160"
        height="28"
        viewBox="0 0 111 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M65.0082 15.7865C100.199 12.0577 108.741 3.83731 110.135 0.914062L0.00927734 0.914071L0.00927896 16.9908C8.37324 18.1601 30.8655 19.4042 65.0082 15.7865Z"
          fill={shapeColor}
        />
      </svg>

      <div className="styleButton-content-wrapper">
        {icon && <div className="styleButton-icon">{icon}</div>}
        <div className="styleButton-text-content">
          <div className="styleButton-content-row">
            <span className="styleButton-content">{content}</span>
            {tooltipText && <Tooltip title={content} content={tooltipText} />}
          </div>
          {subtitle && <span className="styleButton-subtitle">{subtitle}</span>}
        </div>
      </div>

      <svg
        className="styleButton-icon-bottom-right"
        width="280"
        height="52"
        viewBox="0 0 186 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_54620_1532)">
          <path
            d="M102.58 15.493C38.5252 15.493 7.8007 28.1851 0.445312 34.5312H185.801V0.685547C184.75 5.62137 166.635 15.493 102.58 15.493Z"
            fill={shapeColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_54620_1532">
            <path
              d="M0.445312 0.685547H185.801V24.5312C185.801 30.0541 181.324 34.5312 175.801 34.5312H0.445312V0.685547Z"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </button>
  );
};

export default StyleButton;
